import React, { PureComponent } from "react";
import { connect } from "react-redux";
import RadioGroup from '@mui/material/RadioGroup';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import { TextInput, Text, Modal, Services, Checkbox } from '@simplybenefits/sb-ui-library';

import { notifyAllEmployees, notifyEmployee } from '../../../actions/accounts.js';
import * as notifier from '../../../actions/notifier.js';

class NotifyDialog extends PureComponent {
    state = {
        selectedMessage: null,
        selectedTypes: {
            email: false,
            push: false
        },
        customInput: {
            subject: '',
            message: ''
        },
        response: null,
        subjectError: false,
        messageError: false
    };

    _typeChange = (type) => {
        this.setState({
            selectedTypes: {
                ...this.state.selectedTypes,
                [type]: !this.state.selectedTypes[type]
            }
        });
    };

    _setSelectedMessage = (event) => {
        this.setState({
            selectedMessage: event.target.value
        });
    };

    _onBlur = async (type) => {
        this.setState({
            [`${ type }Error`]: await Services.validateInput(type, this.state.customInput[type])
        });
    };

    _handleCustomInputChange = (type, event) => {
        this.setState({
            customInput: {
                ...this.state.customInput,
                [type]: event.target.value
            }
        });
    };

    _sendNotification = async () => {
        const { selectedTypes, selectedMessage, customInput } = this.state;

        if (!selectedTypes.email && !selectedTypes.push) {
            this.props.dispatch(notifier.displayError({
                verbiage: 'Please select a notification type.'
            }));

            return;
        }

        if (!selectedMessage) {
            this.props.dispatch(notifier.displayError({
                verbiage: 'Please select a notification message.'
            }));

            return;
        }

        if (selectedMessage === 'custom' && customInput.subject.length < 1) {
            this.setState({
                subjectError: 'Please provide a subject for your notification.'
            });

            return;
        }

        if (selectedMessage === 'custom' && customInput.message.length < 2) {
            this.props.dispatch(notifier.displayError({
                verbiage: 'Please provide a custom message to be sent.'
            }));

            this.setState({
                messageError: 'Please provide a message for your notification.'
            });

            return;
        }

        const data = {
            selectedMessage: this.state.selectedMessage,
            selectedTypes: this.state.selectedTypes,
            customInput: this.state.customInput
        };

        let response = null;

        if (this.props.notificationUser) {
            response = await this.props.dispatch(notifyEmployee(this.props.notificationUser, this.props.accountID, data));
        } else {
            response = await this.props.dispatch(notifyAllEmployees(this.props.accountID, data));
        }

        // clear the state
        this.setState({
            selectedMessage: null,
            selectedTypes: {
                email: false,
                push: false
            },
            customInput: {
                subject: '',
                message: ''

            },
            response,
            subjectError: false,
            messageError: false
        });

        this.props.toggleNotificationModal();
    };

    _handleResponseClose = () => {
        this.setState({
            response: null
        });
    };

    render() {
        const { notificationModalOpen, toggleNotificationModal } = this.props;

        if (this.props.blockEnrollments === 1) {
            return (
                <Modal
                    open={notificationModalOpen && !this.state.response}
                    onClose={toggleNotificationModal}
                    title="Notify Members"
                    primaryButton={{
                        label: "Close",
                        onClick: toggleNotificationModal
                    }}
                    loader={this.props.loader}
                >
                    <Text medium>
                        Your account is still pending review. During this time user notifications are disabled. We will notify you once your account is ready to send notifications.
                    </Text>
                </Modal>
            );
        }

        if (this.state.response) {
            return (
                <Modal
                    open={this.state.response}
                    onClose={this._handleResponseClose}
                    title="Notice!"
                    loader={this.props.loader}
                >
                    <Text medium>
                        { `Some notifications were sent successfully.\n\n${ this.state.response }` }
                    </Text>
                </Modal>
            );
        }

        if (notificationModalOpen) {
            return (
                <Modal
                    open={notificationModalOpen && !this.state.response}
                    onClose={toggleNotificationModal}
                    title="Notify Members"
                    primaryButton={{
                        onClick: this._sendNotification
                    }}
                    loader={ this.props.loader }
                >
                    <Text medium light>
                        Select a notification and message type below or choose to send a custom message of your making.
                        The getting started notification will provide details on account setup and how to install the Simply Benefits app.
                    </Text>

                    <Text small display="block" margin="20px 0 0 0">
                        Notification Type
                    </Text>

                    <FormGroup row>
                        <FormControlLabel
                            label="Email"
                            control={ <Checkbox checked={this.state.selectedTypes.email} onChange={() => this._typeChange('email')} color="secondary"/> }
                        />

                        <FormControlLabel
                            label="Push Notification"
                            control={ <Checkbox checked={this.state.selectedTypes.push} onChange={() => this._typeChange('push')} color="secondary"/> }
                        />
                    </FormGroup>

                    <Text small light display="block" margin="10px 0 0 0">
                        Message Type
                    </Text>

                    <RadioGroup row value={this.state.selectedMessage} onChange={this._setSelectedMessage}>
                        {
                            (this.props.currentAccountMeta.isPrivateLabel || this.props.currentAccountMeta.isMarketplaceOnly) ?
                                <FormControlLabel value="welcome" control={<Radio color="secondary" />} label="Marketplace Enrollment" />
                                :
                                <FormControlLabel value="welcome" control={<Radio color="secondary" />} label="Getting Started" />
                        }

                        <FormControlLabel value="custom" control={<Radio color="secondary" />} label="Custom" />
                    </RadioGroup>

                    {
                        this.state.selectedMessage === 'custom' &&
                            <React.Fragment>
                                <TextInput
                                    label="Custom Subject"
                                    value={this.state.customInput.subject}
                                    variant="outlined"
                                    onBlur={() => this._onBlur('subject')}
                                    onChange={(value) => this._handleCustomInputChange('subject', value)}
                                    error={Boolean(this.state.subjectError)}
                                    helperText={this.state.subjectError}
                                    fullWidth
                                    autoFocus
                                />

                                <TextInput
                                    label="Custom Message"
                                    value={this.state.customInput.message}
                                    variant="outlined"
                                    onBlur={() => this._onBlur('message')}
                                    onChange={(value) => this._handleCustomInputChange('message', value)}
                                    error={Boolean(this.state.messageError)}
                                    helperText={this.state.messageError}
                                    fullWidth
                                    multiline={true}
                                    rowsMax={8}
                                    rows={8}
                                />
                            </React.Fragment>
                    }
                </Modal>
            );
        }

        return null;
    }
}

export default connect()(NotifyDialog);